// src/api/election.js
import axios from 'axios';

const API = '/api';

export const electionApi = {
    // Админские
    getCandidates: (config) => axios.get(`${API}/admin/candidates`, config),
    createCandidate: (formData, config) => axios.post(`${API}/admin/candidates`, formData, {
        ...config,
        headers: {...config?.headers, 'Content-Type': 'multipart/form-data'}
    }),
    updateCandidate: (id, formData, config) => axios.patch(`${API}/admin/candidates/${id}`, formData, {
        ...config,
        headers: {...config?.headers, 'Content-Type': 'multipart/form-data'}
    }),
    deleteCandidate: (id, config) => axios.delete(`${API}/admin/candidates/${id}`, config),

    getSpoiledPhrases: (config) => axios.get(`${API}/admin/spoiled-phrases`, config),
    createSpoiledPhrase: (text, config) => axios.post(`${API}/admin/spoiled-phrases`, {text}, config),
    updateSpoiledPhrase: (id, text, config) => axios.patch(`${API}/admin/spoiled-phrases/${id}`, {text}, config),
    deleteSpoiledPhrase: (id, config) => axios.delete(`${API}/admin/spoiled-phrases/${id}`, config),

    getElectionSettings: (config) => axios.get(`${API}/admin/election/settings`, config),
    updateElectionSettings: (data, config) => axios.put(`${API}/admin/election/settings`, data, config),
    prepareRound: (roundNumber, durationMinutes, config) => axios.post(`${API}/admin/election/prepare-round`, {
        round_number: roundNumber,
        duration_minutes: durationMinutes
    }, config),
    startRound: (roundNumber, durationMinutes, config) => axios.post(`${API}/admin/election/start-round`, {
        round_number: roundNumber,
        duration_minutes: durationMinutes
    }, config),
    finishRound: (config) => axios.post(`${API}/admin/election/finish-round`, {}, config),
    publishResults: (roundNumber, config) => axios.post(`${API}/admin/election/publish-results`, {
        round_number: roundNumber
    }, config),
    getResults: (roundNumber, config) => axios.get(`${API}/admin/election/results/${roundNumber}`, config),
    getTopCandidates: (roundNumber, config) => axios.get(`${API}/admin/election/top/${roundNumber}`, config),
    correctVotes: (roundId, candidateId, delta, config) => axios.post(`${API}/admin/election/correct-votes`, {
        round_id: roundId,
        candidate_id: candidateId,
        delta
    }, config),
    selectWinner: (candidateId, config) => axios.post(`${API}/admin/election/select-winner`, {candidate_id: candidateId}, config),
    clearWinner: (config) => axios.post(`${API}/admin/election/clear-winner`, {}, config),
    finalizeCandidate: (candidateId, inFinal, config) => axios.post(`${API}/admin/election/finalize`, {candidate_id: candidateId, in_final: inFinal}, config),
    previewElection: (config) => axios.get(`${API}/admin/election/preview`, config),
    resetElection: (config) => axios.post(`${API}/admin/election/reset`, {}, config),  // ДОБАВЛЕНО

    // Публичные
    getElectionStatus: (token, config) => axios.get(`${API}/election/status`, {params: {token}, ...config}),
    vote: (token, candidateId, spoiled = false, config) => axios.post(`${API}/election/vote?token=${token}`, {
        candidate_id: candidateId,
        spoiled
    }, config),
    getPublishedResults: (config) => axios.get(`${API}/election/results`, config),
    getRoundResults: (roundNumber, config) => axios.get(`${API}/election/round-results/${roundNumber}`, config),
    getWinner: (config) => axios.get(`${API}/election/winner`, config),
};

export const WS_URL = (token) => {
    const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
    return `${protocol}//${window.location.host}/ws/election?token=${token}`;
};